export const isLocalStorageAvailable = () => {
  const test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

const getParser = field => {
  switch (field) {
    case 'area_flat':
    case 'investments_floor':
    case 'investments_rooms':
    case 'investments_number':
    case 'balcony':
      return x => Number(x[field]);
    default:
      return x => x[field].toUpperCase();
  }
};

export const sortBy = (field, isReversed) => {
  const key = getParser(field);

  const reverse = !isReversed ? 1 : -1;

  return (a, b) => {
    return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
  };
};
